<template>
  <div class="echart-content" ref="echart"></div>
</template>
<script>
import * as echarts from 'echarts'
export default {
  props: {
    xList: {
      type: Array,
      default: () => []
    },
    yList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      chartNode: null
    }
  },
  watch: {},
  mounted() {
    this.initEchart()
  },
  methods: {
    initEchart() {
      let el = this.$refs.echart
      if (el) {
        this.chartNode = echarts.init(el)
        // 绘制图表
        this.setOption(this.chartNode, this.xList, this.yList)
      }
    },
    setOption(chart, xList, yList) {
      let startValue = xList.length - 7
      startValue = startValue > 0 ? startValue : 0
      let endValue = xList.length - 1
      endValue = endValue > 0 ? endValue : 0
      var option = {
        dataZoom: [
          {
            type: 'inside',
            startValue: startValue,
            endValue: endValue
            // zoomLock: true,
            //  preventDefaultMouseMove: false //禁止canvas上下滑动
          }
        ],
        tooltip: {
          show: true,
          trigger: 'axis',
          axisPointer: {
            type: 'line',
            label: {
              show: true,
              backgroundColor: '#6a7985'
            }
          }
        },
        grid: { top: '10%', bottom: '20%', left: '5%', right: '5%' },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          splitLine: {
            show: true,
            lineStyle: {}
          },
          // 更改x轴线的颜色
          axisLine: {
            lineStyle: {
              color: '#e6e6e6',
              width: 1 //x轴线的宽度
            }
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: 'rgba(0,0,0,0.5)', //更改坐标轴文字颜色
              fontSize: 10 //更改坐标轴文字大小
            }
          },
          data: xList
        },
        yAxis: {
          show: false,
          type: 'value',
          splitLine: {
            show: true,
            lineStyle: {}
          },
          min: function (value) {
            return value.min - ((value.max - value.min) / 0.5) * 0.3
          },
          max: function (value) {
            return value.max + ((value.max - value.min) / 0.5) * 0.2
          }
        },
        series: [
          {
            data: yList,
            type: 'line',
            symbol: 'circle', //将小圆点改成实心 不写symbol默认空心
            symbolSize: 8, //小圆点的大小
            lineStyle: {
              width: 4,
              color: '#866BB8' //曲线的颜色
            },
            itemStyle: {
              color: '#866BB8', //点的颜色
              borderWidth: 1,
              borderColor: '#fff'
            },
            label: {
              normal: {
                show: true,
                position: 'top',
                fontSize: 10
              }
            },
            areaStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: 'rgba(134, 107, 184, 0.2)' // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: 'rgba(134, 107, 184, 0)' // 区域100% 处的颜色
                  }
                ],
                global: false // 缺省为 false
              }
            }
          }
        ]
      }
      chart.setOption(option)
    }
  }
}
</script>
<style lang="scss" scoped>
.echart-content {
  width: 100%;
  height: 100%;
}
</style>
